/* eslint-disable prettier/prettier */
/* eslint-disable no-nested-ternary */
// material-ui
import { Chip, Typography, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import axios from 'axios';
import useTweets from 'hooks/useTweets';
import { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import TweetsyConfig from 'TweetsyConfig';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import ShuffleBtn from '../dashboard/ShuffleBtn';
import EngagementCard from './EngagementCard';
import EngagementList from './EngagementList';
import niche from './engagementNiche';


const NicheEngagement = () => {
    const theme = useTheme();
    const [isShuffling, setIsShuffling] = useState(false)
    const { engagementTweet, setEngagementTweet, pageEngagement, setPageEngagement, engagementNiche, setEngagementNiche } = useTweets();

    // load tweets
    // https://node.tweetsy-backend.com/engagementListTweets?niche=SaaSengage&page=1&size=10
    useEffect(() => {
        axios
            .get(`${TweetsyConfig.getNodeUrl()}engagementListTweets?niche=${engagementNiche}engage&page=${pageEngagement.page}&size=30`)
            .then((res) => {
                console.log('🧪 engagement tweet', res.data)

                setEngagementTweet(res.data.tweets);
                setPageEngagement({ ...pageEngagement, lastPage: res.data.pages });

                if (isShuffling) {
                    document.body.scrollTop = 0; // For Safari
                    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                }
            })
            .catch((e) => console.log('Got error loading tweet: ', e))
            .finally(() => setIsShuffling(false));
    }, [pageEngagement.page, engagementNiche]);


    return (
        <Box>
            <Box sx={{ mb: 5 }}>
                {niche.map((cat) => (
                    <Chip
                        key={cat.value}
                        label={cat.name}
                        sx={{
                            m: '3px',
                            // bgcolor: cat.value === engagementNiche ? '#2196f3' : theme.palette.mode === 'dark' ? '#29314f' : '#d5e3f3',
                            bgcolor:
                                cat.value === engagementNiche
                                    ? '#2196f3'
                                    : theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[50],
                            // color: cat.value === engagementNiche ? 'white' : theme.palette.mode === 'dark' ? '#bdc8f0' : '#626364'
                            color: cat.value === engagementNiche ? 'white' : theme.palette.grey[500]
                        }}
                        onClick={() => {
                            setEngagementNiche(cat.value);
                            // reset page
                            setPageEngagement({ ...pageEngagement, page: 0 });
                        }}
                    />

                ))}
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                {/* Suffle btn */}
                {engagementTweet.length !== 0 && (
                    <ShuffleBtn
                        isShuffling={isShuffling}
                        setIsShuffling={setIsShuffling}
                        lastpage={pageEngagement.lastPage}
                        setPage={setPageEngagement}
                        prevPage={pageEngagement}
                        theme={theme}
                        // new
                        setTweet={setEngagementTweet}
                    />
                )}
            </Box>

            <EngagementList tweets={engagementTweet} />

            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                {/* Suffle btn */}
                {engagementTweet.length !== 0 && (
                    <ShuffleBtn
                        isShuffling={isShuffling}
                        setIsShuffling={setIsShuffling}
                        lastpage={pageEngagement.lastPage}
                        setPage={setPageEngagement}
                        prevPage={pageEngagement}
                        theme={theme}
                    />
                )}
            </Box>

            <ToastContainer position="bottom-right" autoClose={2000} />
        </Box >
    )
};

export default NicheEngagement;
